// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"HeaderContainer_headerContainer__E8G4J","darkfont":"HeaderContainer_darkfont__FiPfC","hightlighted":"HeaderContainer_hightlighted__2Uw-z"};